import { Loader2 } from 'lucide-react';

interface SyncingBadgeProps {
  show: boolean;
}

/**
 * Dấu "đang kéo bản mới từ nhà cái", đặt cạnh tiêu đề hộp thoại lịch sử.
 *
 * Cố tình KHÔNG che bảng: dữ liệu trong DB đã hiện rồi và vẫn đọc được bình
 * thường, lượt đồng bộ chỉ có thể thêm dòng mới vào. Phủ một lớp "đang tải" lên
 * thứ đang xem được là lấy mất của người dùng cái họ vừa mở ra để xem.
 */
export function SyncingBadge({ show }: SyncingBadgeProps) {
  if (!show) return null;

  return (
    <span className="text-warning bg-warning/10 inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[10px] font-bold">
      <Loader2 size={10} className="animate-spin" />
      Đang đồng bộ
    </span>
  );
}
